import { ListItem, ListItemProps } from '@chakra-ui/react';
import React from 'react';

export const CmListItem: React.FC<ListItemProps> = ({ children, ...rest }) => {
  // @ts-ignore TS2590
  return <ListItem {...rest}>{children}</ListItem>;
};
